module.exports = __webpack_public_path__ + "static/media/30OIOS12.b2a744b5.jpg";